import { lazy } from 'react';
import {
    CREATE_PERMISSION,
    LEAD_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';
import { LeadAccessGuard, PermissionsGuard } from 'src/routing/components';

const LeadListView = lazy(() => import('src/views/lead/LeadListView'));

export const Leads = [
    {
        exact: true,
        path: '/create/lead',
        guard: PermissionsGuard,
        roles: {
            permission: LEAD_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/lead/LeadCreateView')),
    },
    {
        exact: true,
        guard: [PermissionsGuard, LeadAccessGuard],
        roles: {
            permission: LEAD_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/leads/:id',
        component: lazy(() => import('src/views/lead/LeadDetailsView')),
    },
    {
        exact: true,
        guard: [PermissionsGuard, LeadAccessGuard],
        roles: {
            permission: LEAD_AUTH,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/leads/:id/edit',
        component: lazy(() => import('src/views/lead/LeadEditView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: LEAD_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/leads',
        component: () => <LeadListView leadType="digital" />,
    },
];

export const Showroom = [
    {
        exact: true,
        path: '/create/showroom-lead',
        guard: PermissionsGuard,
        roles: {
            permission: LEAD_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/lead/ShowRoomCreateView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: LEAD_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/showroom-leads',
        component: () => <LeadListView leadType="showroom" />,
    },
];

export const BDC = [
    {
        exact: true,
        path: '/create/bdc',
        guard: PermissionsGuard,
        roles: {
            permission: LEAD_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/lead/BDCCreateView')),
    },
    {
        exact: true,
        guard: [PermissionsGuard, LeadAccessGuard],
        roles: {
            permission: LEAD_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/bdc/:id',
        component: lazy(() => import('src/views/lead/LeadDetailsView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: LEAD_AUTH,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/bdc/:id/edit',
        component: lazy(() => import('src/views/lead/BDCEditView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: LEAD_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/bdc',
        component: () => <LeadListView leadType="bdc" />,
    },
];
